export const walletActionTypes = {
  WALLET_TRANSACTION_LOAD: "WALLET_TRANSACTION_LOAD",
  WALLET_TRANSACTION_SUCCESS: "WALLET_TRANSACTION_SUCCESS",
  WALLET_TRANSACTION_ERROR: "WALLET_TRANSACTION_ERROR",
  JUSPAY_TRANSACTION_SUCCESS: "JUSPAY_TRANSACTION_SUCCESS",
  JUSPAY_TRANSACTION_ERROR: "JUSPAY_TRANSACTION_ERROR",
  CONVERSION_RATE_LOAD: "CONVERSION_RATE_LOAD",
  CONVERSION_RATE_SUCCESS: "CONVERSION_RATE_SUCCESS",
  CONVERSION_RATE_ERROR: "CONVERSION_RATE_ERROR",
  SET_DEPOSIT_GST: "SET_DEPOSIT_GST",
};
